import React, { useState } from "react";
import styles from "../Reports/report.module.css";
import SlideBox from "../../common/SlideBox/SlideBox";
import { useSelector } from "react-redux";
import { MastersRegistry } from "../../Privillages/MastersRegistry";

const MastersView = () => {
  const [flag, setFlag] = useState(false);
  const [report, setReport] = useState("");

  const { catalog = {}, allowed = [] } = useSelector((state) => state.userPrivileges);

  const userPrivilegeIdSet = new Set(allowed);

  const toggleRightBar = (type) => {
    if (type) setReport(type);
    setFlag((prev) => !prev);
  };

  const onToggle = (key) => {
    setReport(key);
    setFlag((v) => !v);
  };

  const mastersConfig = catalog?.Masters || {};
  const SelectedMaster = MastersRegistry.find((t) => t?.key === report);

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="card text-center">
          <div className="card-body">
            <SlideBox flag={flag} toggleRightBar={onToggle}>
              {SelectedMaster?.component &&
                React.createElement(SelectedMaster.component, {
                  type1: report,
                  toggleRightBar: onToggle,
                })}
            </SlideBox>

            <div className="row text-center text-lg-start">
              {MastersRegistry?.map((item, idx) => {
                const subId = mastersConfig?.idMap?.[item?.requiredSub];
                if (!subId || !userPrivilegeIdSet?.has(subId)) return null;
                return (
                  <div
                    key={idx}
                    className={`col-lg-3 col-md-3 col-4 mb-5 ${styles["report-icon"]}`}
                  >
                    <div
                      className="d-flex flex-column justify-content-center align-items-center"
                      onClick={() => toggleRightBar(item?.key)}
                    >
                      <img
                        className="img-fluid img-thumbnail mb-2"
                        src={item?.icon || "/images/default-icon.png"}
                        alt={item?.title}
                        width="60"
                        height="60"
                        style={{ objectFit: "contain" }}
                      />
                      <h5 className="mt-2 text-primary text-md text-sm">
                        {item?.label || "NA"}
                      </h5>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MastersView;